<template>
  <div>
    <div class="tableContent" v-for="(item, index) in data" :key="index">
      <div class="positionName">
        <p :title="item.position_name">{{ item.position_name }}</p>
        <p :title="item.company_name">{{ item.company_name }}</p>
      </div>
      <div class="positionRequirement">
        <span>{{ item.city }}</span>
        <span>|</span>
        <span v-if="item.years === 9">不限</span>
        <span v-if="item.years === 7">实习生</span>
        <span v-if="item.years === 1">应届生</span>
        <span v-if="item.years === 2">1-3年</span>
        <span v-if="item.years === 3">3-5年</span>
        <span v-if="item.years === 4">5-10年</span>
        <span v-if="item.years === 5">10年以上</span>
        <span>|</span>
        <span v-if="item.educ === 9">不限</span>
        <span v-if="item.educ === 1">大专</span>
        <span v-if="item.educ === 2">本科</span>
        <span v-if="item.educ === 3">硕士</span>
        <span v-if="item.educ === 4">博士</span>
        <span v-if="item.educ === 5">MBA</span>
        <span>|</span>
        <span>{{ item.income }}</span>
      </div>
      <div class="positionNumber" @click.stop="handleGoDeliveryNumber(item)">
        <p>投递次数：{{ item.delivery_num }}</p>
      </div>
      <div class="positionShowNumber">
        <p>被查看数：{{ item.view_num }}次</p>
      </div>
      <div class="positionOperation">
        <span v-if="item.years==8" @click="refresh8(item.id)">刷新</span>
        <span @click="handlePositionDetails(item.id)">详情</span>
        <span @click.stop="handleEditPosition(item.id)">编辑</span>
        <span @click.stop="handleStopPosition(item)">{{
          positionStatus == "on" ? "暂停" : "开启"
        }}</span>
      </div>
    </div>
    <div v-show="!data.length" class="no">暂无数据</div>
    <div class="comtable-compage" :page="page">
      <p>
        共 {{ page.total }} 条记录 第 {{ page.current_page }} /
        {{ page.last_page }} 页
      </p>
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.current_page"
        :page-size="page.per_page"
        :total="page.total"
        prev-text="<上一页"
        next-text="下一页>"
        @current-change="tablePageChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
    positionStatus: {
      type: String,
    }
  },
  computed:{

  },
  mounted() {

  },
  methods: {
    tablePageChange(events) {
      this.$emit("pageChange", events);
    },
    // 跳转职位详情
    handlePositionDetails(id) {
      this.$router.push({
        path: "/positiondetails",
        query: { id: id },
      });
    },
    // 跳转投递人数列表页
    handleGoDeliveryNumber(val) {
      let paramsid = val.id;
      sessionStorage.setItem("companyname", val.company_name);
      sessionStorage.setItem("positionname", val.position_name);
      sessionStorage.setItem("createtime", val.updated_time);
      this.$router.push({
        path: "/deliveryNumber",
        query: { id: paramsid },
      });
    },
    handleEditPosition(id) {
      this.$emit("handleEditPosition", id);
    },
    handleStopPosition(item) {
      this.$emit("handleStopPosition", item);
    },
    refresh8(id){
      this.$emit("refresh8", id);
    }
  },
};
</script>
<style scoped>
.no{
  line-height: 60px;
  color: #909399;
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #EBEEF5;
}
.tableContent {
  width: 100%;
  height: 76px;
  margin: 0 auto;
  border-bottom: 1px solid #efefef;
  display: flex;
  align-items: center;
}
.tableContent .positionName{
  width: 297px;
}
.tableContent .positionName p{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.tableContent .positionName p:first-child {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
}
.tableContent .positionName p:last-child {
  font-size: 12px;
  color: rgba(74, 144, 226, 1);
  margin-top: 4px;
}
.tableContent .positionRequirement span {
  font-size: 12px;
  color: #666;
}
.tableContent .positionRequirement{
  width: 276px;
}
.tableContent .positionNumber {
  width: 148px;
}
.tableContent .positionShowNumber {
  width: 180px;
}
.tableContent .positionOperation{
  width: 119px;
  display: flex;
  justify-content: space-between;
}
.tableContent .positionOperation span {
  font-size: 12px;
  color: #0077ff;
  cursor: pointer;
}
.tableContent .positionShowNumber p {
  font-size: 12px;
  color: #888;
}
.tableContent .positionNumber p {
  font-size: 12px;
  color: #888;
  cursor: pointer;
}
/* page */
.comtable-compage {
  width: 100%;
  padding: 40px 0 80px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
}

.comtable-compage p {
  display: inline-block;
  height: 46px;
  line-height: 46px;
  font-size: 12px;
  color: #888;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
<style>
/* 分页样式 */
.comtable-compage .el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  height: 36px !important;
  line-height: 36px !important;
  padding: 0 7px !important;
}
.el-pager li.active + li {
  border: 1px solid #eaeaea !important;
}
.el-pager li {
  padding: 0 14px !important;
  height: 36px !important;
  line-height: 36px !important;
  margin: 0 10px !important;
}
.el-pagination .btn-next,
.el-pagination .btn-prev,
.el-pagination .el-pager li {
  background-color: #fff !important;
  border-radius: 2px !important;
  border: 1px solid #eaeaea !important;
  color: #555 !important;
}
.el-pagination .el-pager li:not(.disabled).active {
  background-color: #fff !important;
  border-radius: 2px !important;
  border: 1px solid #0077ff !important;
  color: #0077ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TablePagePositionList.vue